export function obterListaCteModalidade() {
  return (
    [
      { label: '01 - Rodoviário', value: 'RODOVIARIO' },
      { label: '02 - Aéreo', value: 'AEREO' },
      { label: '03 - Aquaviário', value: 'AQUAVIARIO' },
      { label: '04 - Ferroviário', value: 'FERROVIARIO' },
      { label: '05 - Dutoviário', value: 'DUTOVIARIO' },
      { label: '06 - Multimodal', value: 'MULTIMODAL' },
    ]
  );
}
